import { defineStore } from 'pinia'
export const useCurrentUserStore = defineStore('currentUser', {
    state: () => (
        {
            user: null,
            internal_company : 0,
            company_data : {
                id : null,
                name: "",
                billing: {
                    id: null,
                    country_id: null,
                },
                settings: {
                    vat: null,
                    date_format: "Y-m-d",
                    date_timezone: null,
                    defaults: {
                        number_local : null,
                        language: null,
                        internal_unit: null,
                        sales_unit: null,
                    }
                }
            },
            take: 20,
            current_timezone : null,
            available_timezones: [
                {
                    name: "Europe/Berlin",
                    value : "Europe/Berlin",
                },
                {
                    name: "Europe/London",
                    value : "Europe/London",
                },
                {
                    name: "America/New York",
                    value : "America/New_York",
                },
            ],
            debugs: {
                products_additionals : false,
                global : false,
            }
        }),
    actions: {
      async get(id){
        this.loading = true;
        await this.axios.get("/api/v1/" + this.companyId + "/company/" + id).then((response) => {
            this.loading = false;
            return response.data.data
        });
        this.loading = false;
    },
    },
  })
